import { QueryClient } from '@tanstack/react-query';
import { cleanupExpiredStorage } from './query-persistence';

/**
 * Optimized QueryClient configuration to reduce repeated requests
 * and improve application performance
 */
export const createQueryClient = () => {
  // Clean expired data on initialization
  cleanupExpiredStorage();

  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: 'always',
        refetchOnMount: 'always',
        retry: (failureCount, error: any) => {
          if (error?.response?.status >= 400 && error?.response?.status < 500) {
            return false;
          }
          return failureCount < 3;
        },

        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
    },
  });

  // return new QueryClient({
  //   defaultOptions: {
  //     queries: {
  //       // Time that data is considered "fresh" (doesn't need refetch)
  //       staleTime: 5 * 60 * 1000, // 5 minutes

  //       // Time that data is kept in cache
  //       cacheTime: 10 * 60 * 1000, // 10 minutes

  //       // Don't refetch automatically when window regains focus
  //       refetchOnWindowFocus: false,

  //       // Don't refetch automatically when network reconnects
  //       refetchOnReconnect: false,

  //       // Don't refetch automatically when component mounts
  //       refetchOnMount: false,

  //       // Maximum number of retries in case of error
  //       retry: (failureCount, error: any) => {
  //         // Don't retry on 4xx errors (client errors)
  //         if (error?.response?.status >= 400 && error?.response?.status < 500) {
  //           return false;
  //         }
  //         // Maximum 3 retries for other errors
  //         return failureCount < 3;
  //       },

  //       // Delay between retries (exponential)
  //       retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

  //       // Keep previous data while loading new data
  //       keepPreviousData: true,

  //       // Don't show errors in console for cancelled queries
  //       notifyOnChangeProps: ['data', 'error', 'isLoading', 'isFetching'],
  //     },
  //     mutations: {
  //       // Maximum number of retries for mutations
  //       retry: 1,

  //       // Don't show errors in console for cancelled mutations
  //       onError: (error) => {
  //         // Mutation error handled by components
  //       },
  //     },
  //   },
  // });
};

/**
 * Specific configurations for different types of queries
 */
export const queryConfigs = {
  // For reference data that changes little (countries, segments, etc.)
  referenceData: {
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  },

  // For lists that may change more frequently
  listData: {
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: true,
  },

  // For user data that may change
  userData: {
    staleTime: 1 * 60 * 1000, // 1 minute
    cacheTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
  },

  // For data that needs to always be up to date
  realTimeData: {
    staleTime: 0, // Always considered stale
    cacheTime: 1 * 60 * 1000, // 1 minute
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
  },
};
